import { useEffect } from 'react';
import { captureQueryError } from '@/services/error';

export function useReportQueryError(error: Error | null | undefined, context: string): void {
  useEffect(() => {
    if (error && process.env.NODE_ENV !== 'test') {
      captureQueryError(error, context);
    }
  }, [error, context]);
}
